/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
 
document.addEventListener("mouseover", function (e) {
  const grid = e.target.closest(".prod .gm-grid");
  const menu = document.querySelector(".prod");

  if (!grid || !menu) return;

  menu.classList.add("gm-active");
});

document.addEventListener("mouseout", function (e) {
  const grid = e.target.closest(".prod .gm-grid");
  const menu = document.querySelector(".prod");

  if (!grid || !menu) return;

  // check if cursor actually left the grid
  if (!grid.contains(e.relatedTarget)) {
    menu.classList.remove("gm-active");
  }
});


document.addEventListener("mouseover", function (e) {
  const grid = e.target.closest(".collect .gm-grid");
  const menu = document.querySelector(".collect");

  if (!grid || !menu) return;

  menu.classList.add("gm-active");
});

document.addEventListener("mouseout", function (e) {
  const grid = e.target.closest(".collect .gm-grid");
  const menu = document.querySelector(".collect");

  if (!grid || !menu) return;

  // check if cursor actually left the grid
  if (!grid.contains(e.relatedTarget)) {
    menu.classList.remove("gm-active");
  }
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
